"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDateFilterParam = void 0;
const toDateFilterParam = (date) => {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}T00:00:00.000`;
};
exports.toDateFilterParam = toDateFilterParam;
